import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ROUTES } from './tournament-team.routes';
import { TournamentTeamCardComponent } from './tournament-team-card/tournament-team-card.component';
import { TournamentTeamComponent } from './tournament-team.component';
import { TournamentTeamGamesComponent } from './tournament-team-games/tournament-team-games.component';
import { TournamentTeamStatisticComponent } from './tournament-team-statistic/tournament-team-statistic.component';
import {
  ButtonModule,
  DataSliderModule,
  DropdownModule,
  ProgressModule, ShareModule,
  SvgIconModule,
  TableModule,
  UtilsModule
} from '@mtgame/ui';
import { StatisticTableModule } from '../../shared/statistic-table/statistic-table.module';
import { SharedModule } from '@shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { StatisticTableGroupedModule } from '../../shared/statistic-table-grouped/statistic-table-grouped.module';
import { TournamentTeamPhotosComponent } from './tournament-team-photos/tournament-team-photos.component';
import { TournamentMediaModule } from '../../shared/tournament-media/tournament-media.module';
import { TournamentTeamService } from '@core/services/tournament-team.service';
import { tournamentTeamFactory } from '@core/services/tournament-team.factory';
import { TournamentTeamResolver } from './tournament-team.resolver';
import { HockeyTournamentTeamService } from '@core/services/hockey-tournament-team.service';
import { BasketballTournamentTeamService } from '@core/services/basketball-tournament-team.service';
import { VolleyballTournamentTeamService } from '@core/services/volleyball-tournament-team.service';
import { FootballTournamentTeamService } from '@core/services/football-tournament-team.service';
import { HandballTournamentTeamService } from '@core/services/handball-tournament-team.service';
import { TeamPhotoDetailComponent } from './tournament-team-photos/team-photo-detail.component';
import { RugbyTournamentTeamService } from '@core/services/rugby-tournament-team.service';
import { StatisticFiltersWidgetModule } from '../../shared/statistic-filters-widget/statistic-filters-widget.module';
import { TournamentTeamUniformComponent } from './tournament-team-uniform/tournament-team-uniform.component';
import {
  TournamentTeamDisqualificationsComponent
} from './tournament-team-disqualifications/tournament-team-disqualifications.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ROUTES),
    UtilsModule,
    SvgIconModule,
    DataSliderModule,
    ProgressModule,
    TableModule,
    StatisticTableModule,
    SharedModule,
    DropdownModule,
    ReactiveFormsModule,
    StatisticTableGroupedModule,
    TournamentMediaModule,
    ButtonModule,
    ShareModule,
    StatisticFiltersWidgetModule,
  ],
  declarations: [
    TournamentTeamComponent,
    TournamentTeamCardComponent,
    TournamentTeamGamesComponent,
    TournamentTeamStatisticComponent,
    TournamentTeamPhotosComponent,
    TeamPhotoDetailComponent,
    TournamentTeamUniformComponent,
    TournamentTeamDisqualificationsComponent,
  ],
  providers: [
    HockeyTournamentTeamService,
    BasketballTournamentTeamService,
    VolleyballTournamentTeamService,
    FootballTournamentTeamService,
    HandballTournamentTeamService,
    RugbyTournamentTeamService,
    {
      provide: TournamentTeamService,
      useFactory: tournamentTeamFactory,
      deps: [Injector]
    },
    TournamentTeamResolver,
  ]
})
export class TournamentTeamModule {}
